<template>
  <div v-if="moduleData.cover" class="common-top" :class="{
    isMobile: isMobile()
  }" :style="`background: url(${moduleData.cover.url}) no-repeat; background-size: 100% 100%;`">
    <div :class="`sys-max-width`">
      <div class="title">{{ moduleData.name }}</div>

      <!-- <div class="desc">{{ moduleData.remark }}</div> -->
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index'

export default {
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {

    }
  },
  methods: {
    isMobile
  }
}
</script>

<style lang="scss">
.common-top {
  padding: 118px 0 127px 0;
  background-size: 100% 100%;

  &.isMobile {
    padding: 60px 20px 55px 20px;

    .desc {
      width: inherit;
    }
  }

  .title {
    font-size: 36px;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 24px;
  }

  .desc {
    width: 488px;
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 20px;
  }
  
}
</style>
